import { CustomReportField, DATA_TYPE_DATE } from './custom-report-field.model';

export const OPERATOR_TYPE_STRING: string = 'string';
export const OPERATOR_TYPE_DATES: string = 'dates';
export const OPERATOR_TYPE_NUMBER: string = 'number';

export interface CustomReportOperatorJSON {
	id: string;
	label: string;
	type: string;
}

export class CustomReportOperator {
	constructor(
		public id: string,
		public label: string,
		public type: string
	) {}

	static fromJSON(json: CustomReportOperatorJSON): CustomReportOperator {
		return Object.assign(
			Object.create(CustomReportOperator.prototype),
			json,
			{}
		);
	}

	static findOperator(
		id: string,
		operators: CustomReportOperator[]
	): CustomReportOperator {
		return operators
			? operators.find((operator) => operator.id === id)
			: null;
	}

	static getOperatorType(
		whereOperator: string,
		operators: CustomReportOperator[]
	): string {
		const operator: CustomReportOperator = this.findOperator(
			whereOperator,
			operators
		);
		return operator ? operator.type : null;
	}

	static getOperatorsForWhereField(
		name: string,
		fields: CustomReportField[],
		dateOperators: CustomReportOperator[],
		stringOperators: CustomReportOperator[]
	): CustomReportOperator[] {
		if (!name) {
			return [];
		}
		const fieldDataType: string = CustomReportField.findFieldDataType(
			name,
			fields
		);
		return fieldDataType === DATA_TYPE_DATE
			? dateOperators
			: stringOperators;
	}
}
